module.exports = __webpack_public_path__ + "img/darren_reddy.0cc4e930.png";